export const isInIframe = window.top !== window.self;
export const isInternal = location.href.indexOf('cainiao.com') < 0;
export const isMobile = /Mobile/.test(navigator.userAgent);
